import { CommissionsFormConditionsHeader } from '../components/CommissionsFormConditionsHeader';
import { CommissionsZeroedInput } from '../components/CommissionsZeroedInput';

export const CommissionsEditConditionsHeader: React.FC = () => {
  return (
    <CommissionsFormConditionsHeader title="Условия комиссии">
      <CommissionsZeroedInput />
    </CommissionsFormConditionsHeader>
  );
};
